export default {

  /**
   * Função responsável por válidar itens do carrinho.
   * Não permite inserir um item avulso caso o carrinho possuir um Kit,
   * ou vice-versa;
   * @returns (true) -> Pode seguir com a inclusão
   * @returns (false) -> Não pode seguir com a inclusão
   */
  validaItensCarrinhoSolar(prod) {
    const isSaleSolar = JSON.parse(localStorage.getItem("isSaleSolar"));
    // Verifica se é um canal Solar
    if (isSaleSolar) {
      // Percorrer carrinho e validar se é diferente o campo "isCustomized" é diferente dos demais
      let carrinho =
        localStorage.getItem("carrinho") != "" ||
        localStorage.getItem("carrinho") == null ||
        localStorage.getItem("carrinho") == undefined
          ? JSON.parse(localStorage.getItem("carrinho"))
          : [];

      if (carrinho.length > 0){
        let validador
        carrinho.forEach(p => {
         validador = p.isCustomized != prod.isCustomized ? false : true
        });
        return validador
      }else {
        return true;
      }
    } else {
      return true;
    }
  }
}